module.exports = __webpack_public_path__ + "static/media/moons_ortodoncia_invisible-1500.ff69b744.webp";